var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 3.054l1.179-1.179 3.823 3.891 3.82-3.891L10 3.055l-4.998 5.07L0 3.055z","fill":"#998F8A"}})])}
var staticRenderFns = []

export { render, staticRenderFns }